import React from "react";
import PropTypes from "prop-types";
import axios from "axios";

class SettingImperialUnits extends React.Component {
  state = { value: this.props.imperialUnits };

  handlerChange = e => {
    const value = e.target.value;
    this.setState({ value });

    axios
      .put(`/accounts/${window.Application.currentAccount.id}.json`, {
        account: { imperial_units: value }
      })
      .then(() => {
        toastr.success("Updated");
      })
      .catch(() => {
        toastr.error("An error occurred, please try again.");
        this.setState({ value: !value });
      });
  };

  render() {
    const { value } = this.state;
    const { allowToEdit } = this.props;

    return (
      <div>
        <h4>
          <b>Unit of Measurement</b>
        </h4>

        <select
          disabled={!allowToEdit}
          className="form-control"
          value={value}
          onChange={this.handlerChange}
        >
          <option value="true">Imperial</option>
          <option value="false">Metric</option>
        </select>
      </div>
    );
  }
}

SettingImperialUnits.propTypes = {
  imperialUnits: PropTypes.bool.isRequired,
  allowToEdit: PropTypes.bool.isRequired
};

export default SettingImperialUnits;
